// extracted by mini-css-extract-plugin
module.exports = {"container":"_2liuR8IQho3OvCuhNnLsgq","cancelBtn":"_2g-ASsx94DtK8CrdxUlm2V","icon":"_11WtHwLjQCNCkJ45r5oOdc","saveBtn":"_3f_TjCyj2aPcs4HssAkzjg"};